var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
class Bar extends Component {
  render() {
    const {
      handleMouseLeave,
      handleMouseOver,
      ...props
    } = this.props;
    return /* @__PURE__ */ jsx("rect", { className: "rd3-barchart-bar", ...props, onMouseOver: handleMouseOver, onMouseLeave: handleMouseLeave });
  }
}
__publicField(Bar, "propTypes", {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  handleMouseOver: PropTypes.func,
  handleMouseLeave: PropTypes.func
});
__publicField(Bar, "defaultProps", {
  fill: "blue"
});
export {
  Bar
};
